/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable one-var */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-prototype-builtins */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    Stack,
    TextField,
    Tooltip,
    Typography,
    Select,
    MenuItem,
    FormHelperText,
    InputLabel,
    Autocomplete,
    FormControlLabel,
    ToggleButtonGroup,
    ToggleButton,
    RadioGroup,
    Radio,
    Chip,
    Popper,
    Paper,
    Avatar,
    Box,
    Skeleton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { GLOBAL_DATE_FORMAT, PAYLOAD_DATE_TIME_FORMAT, THERAPY_MAX_TIME, THERAPY_MIN_TIME, gridSpacing, GETLOCALTIMEZONE } from 'constant';
import { AspyreDateTimePicker as DateTimePicker, AspyreDatePicker as DatePicker } from 'components/common/InputFields';
import axios from 'axios';
import usePermission from 'hooks/usePermission';
import ConfirmationModal from 'components/reusable/ConfirmationModal';
import useAuth from 'hooks/useAuth';
import {
    useAddEventMutation,
    useGetEventDetailsQuery,
    useUpdateRecEventMutation,
    useAddEventCreateMutation,
    useLazyGetPatientSChePreferenceQuery
} from 'store/services/schedule/events';
import moment from 'moment';
import { Close, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { encriptId } from 'utils/encription';
import useSnackbar from 'hooks/useSnackbar';
import Spinner from 'ui-component/Spinner';
import { getEmployeeName } from 'views/therapy/Evaluation/List';
import { getBg } from 'views/Schedule/serviceColors';
import { useGetServicesQuery } from 'store/services/common';
import {
    getInitialValues,
    generateHour,
    generateMinute,
    makeTitle,
    transformData,
    EventSchema,
    visitValues,
    shotDays,
    treatmentDataKeys,
    startTimeKeys,
    recChangeKeys
} from './useEventForm';
import { PatientDropdown } from 'components/reusable/Dropdowns';
import UpdateMoal from './updateMoal';
import { payloadToFormData } from 'utils/payload';
import { keyframes } from '@mui/system';
import { useCheckPermissionMutation } from 'store/services/therapy/evaluation';
import ValidationDialog from 'components/therapy/ValidationDialog';
import { usePatientNameOrderValueGetter } from 'utils/patientNameOrder';
// import { handlePatientChangeV2 } from 'components/AsyncDropdown/onChangeHelper';

// ==============================|| CALENDAR EVENT ADD / EDIT / DELETE ||============================== //

// Define keyframes for glow, bounce, and fast blink
// Define keyframes for glow and bounce without a box
// Define keyframes for glow and bounce without box-shadow

// Define keyframes for vibrate effect

const heartbeat = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
    font-weight: normal; /* Normal weight */

  }
  30% {
    transform: scale(1.2);
    opacity: 0.8;
    font-weight: normal;
  }
  50% {
    transform: scale(1);
    opacity: 1;
    // font-size: 1.2em; /* Increase font size */
    font-weight: bolder; /* Make it bolder */
    color:rgb(226, 72, 0); /* Red color */
  }
  70% {
    transform: scale(1.2);
    opacity: 0.8;
    font-weight: normal;=
  }
  100% {
    transform: scale(1);
    opacity: 1;
    font-weight: normal;

  }
`;

const AddEventFrom = ({ event, range, handleDelete, onCancel, table, tableEdit, isViewOnly = false }) => {
    const anchorRef = useRef(null);
    const scheduleId = event?.sch_id;
    const accessToken = window.localStorage.getItem('accessToken');
    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
    const { hasPermission, isTherapist: isRoleTherapist, isSameAsMasterAdmin, isSuperAdmin } = usePermission();
    const patientNameOrderValueGetter = usePatientNameOrderValueGetter();
    const isTherapist = isRoleTherapist && !isSameAsMasterAdmin;
    const localtimezone = GETLOCALTIMEZONE();

    const hours = generateHour();
    const minute = generateMinute();

    const { notify } = useSnackbar();
    const { user } = useAuth();
    const navigate = useNavigate();

    const [locations, setLocations] = useState(null);
    const [locLoading, setLocLoading] = useState(true);
    const [services, setServices] = useState(null);
    const [employees, setEmployees] = useState(null);
    const [empLoading, setEmpLoading] = useState(true);
    const [patients, setPatients] = useState(null);
    const [patLoading, setPatLoading] = useState(true);
    const [didLocChange, setDidLocChange] = useState(false);
    const [isView, setIsView] = useState(event);
    const [scheduleData, setScheduleData] = useState();
    const [showDelete, setShowDelete] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [updateType, setUpdateType] = useState(false);
    const [editParent, setEditParent] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    // const [preferenceList, setPreferenceList] = useState(null);

    const [addEvent, { isLoading: addLoading }] = useAddEventMutation();
    const [addEventCreate, { isLoading: addCreateLoading }] = useAddEventCreateMutation();
    const [updateEvent, { isLoading: updateLoading }] = useUpdateRecEventMutation();
    const [getPreferences, { data: preferenceList, isLoading: preferenceLoading, isFetching: preferenceFetching }] =
        useLazyGetPatientSChePreferenceQuery();

    const popperOpen = Boolean(anchorEl);

    /**
     * * FORMIK
     */
    const formik = useFormik({
        initialValues: getInitialValues(scheduleData, range),
        validationSchema: EventSchema,
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                if (values.treatment_type === 'individual' && values?.patient?.is_active === false) {
                    notify({
                        message: 'Patient is inactive',
                        severity: 'warning'
                    });
                    return;
                }

                let grpPatients = [];
                if (values.treatment_type === 'group') {
                    grpPatients = values?.grp_patients.map((item) => {
                        return {
                            id: item.id,
                            name: item.user.name,
                            is_active: item.user.is_active
                        };
                    });
                }

                const payload = {
                    fg_color: values.textColor,
                    bg_color: getBg(values.service.service_name.replaceAll(' ', '').toLowerCase()),
                    employees: [values.employee.id],
                    locations: [values.location.id],
                    patients: values.treatment_type === 'group' ? grpPatients.map((item) => item.id) : [values.patient.id],
                    services: [values.service.id],
                    // if  recurent send without conversion
                    start_date_time:
                        values.groupSchedule === '1'
                            ? moment(new Date(values.start)).format(PAYLOAD_DATE_TIME_FORMAT)
                            : moment(new Date(values.start)).utc().format(PAYLOAD_DATE_TIME_FORMAT),
                    ...(values.groupSchedule === '1' && { local_tz: localtimezone }),
                    duration_hour: values.hour,
                    duration_minute: values.minute,
                    title: makeTitle(values.visitType, values.treatment_type === 'group' ? grpPatients : values.patient),
                    description: values.description,
                    visit_type: values.visitType,
                    dates: values.days.map((day) =>
                        moment(new Date(values.start))
                            .weekday(day + 1)
                            .utc()
                            .format(PAYLOAD_DATE_TIME_FORMAT)
                    ),
                    is_grouped: values.treatment_type === 'group' ? 1 : 0,

                    ...(values.groupSchedule === '1' && { event_type: values.eventType }),
                    is_group_schedule: values.groupSchedule === '1' ? true : false,
                    // rec_end_type: values.rec_end_type,
                    ...(values.groupSchedule === '1' &&
                        values.rec_end_type === 'no_of_occurances' && {
                            no_of_occurence: values.noOfOccurence
                        }),
                    ...(values.groupSchedule === '1' &&
                        values.rec_end_type === 'end_date' && {
                            end_date_time: moment(new Date(values.endDateTime)).endOf('day').format(PAYLOAD_DATE_TIME_FORMAT)
                        }),
                    ...(values.eventType === 'weekly' && { week_days: values.weekDays }),

                    ...(values.eventType === 'monthly' &&
                        values.monthly_rec_type === 'weekdayOfMonth' && {
                            week_day: values.monthly_week_day,
                            week_number: values.monthly_week_number
                        }),
                    ...(values.eventType === 'monthly' &&
                        values.monthly_rec_type === 'dayOfMonth' && {
                            // monthly_weekday: values.monthly_week_day,
                            day_of_month: values.monthly_week_day
                        }),
                    ...(values.groupSchedule === '1' &&
                        values.event_nature && {
                            event_nature: values.event_nature
                        })
                };
                if (scheduleData) {
                    payload.sch_id = scheduleData.sch_id;
                }
                const res = await addEvent(payload).unwrap();
                notify({
                    message: scheduleData ? 'Event updated successfully!' : 'Event created successfully!',
                    severity: 'success'
                });

                resetForm();
                onCancel();
                setSubmitting(false);
            } catch (error) {
                console.error(error);
                setSubmitting(false);
                notify({
                    message: error.data?.message || 'Something went wrong!',
                    severity: 'error'
                });
            }
        }
    });
    const { values, errors, touched, handleSubmit, isSubmitting, getFieldProps, setFieldValue, handleBlur } = formik;

    /**
     * * FUNCTION :  SET UP FORMIK VALUES
     */
    const addToForm = (field, value) => {
        setFieldValue(field, value);
    };

    const addToFormArr = (field, value) => {
        if (value.length === 0) {
            setFieldValue(field, []);
        } else {
            setFieldValue(field, value);
        }
    };

    /**
     * * HANDLING API REQUESTS
     */
    const { data: scheduleDetail, isFetching: scheduleLoading } = useGetEventDetailsQuery({ sch_id: scheduleId }, { skip: !scheduleId });

    const { data: serviceData, isFetching: serviceLoading } = useGetServicesQuery(
        {
            filters: {
                locations: [values.location?.id],
                ...(user?.emp_id && { emp_id: user?.emp_id })
                // source: 'schedule'
            }
        },
        {
            skip: !values.location?.id
        }
    );

    /**
     * * FUNCTION :  HANDLING API REQUESTS
     */
    const fetchLocData = useCallback(async () => {
        const payload = {
            filters: {
                status: 1,
                order_col: 'name',
                order: 'ASC'
            }
        };
        if (user.client_id) {
            payload.filters.client_id = user.client_id;
        }

        let res;
        try {
            res = await axios.post(`${API_ENDPOINT}/api/location/`, payload, {
                headers: {
                    SUBTYPE: 'LIST',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            setLocations(res.data.fields);
            setLocLoading(false);
        } catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchEmpData = useCallback(async () => {
        if (!values.location?.id || !values.service?.id) {
            return;
        }
        try {
            const payload = {
                filters: {
                    services: [values.service.id],
                    locations: [values.location.id],
                    source: 'schedular'
                }
            };
            if (user?.client_id) {
                payload.filters.clients = [user?.client_id];
            }
            const res = await axios.post(`${API_ENDPOINT}/api/employees/employee/`, payload, {
                headers: {
                    SUBTYPE: 'listthrp',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            setEmployees(res.data.fields);

            if (isTherapist && !event) {
                const currentEmployee = () => {
                    const therap = res.data?.fields.find((item) => item.emp_id === user?.emp_id);
                    if (therap) {
                        return {
                            id: therap.emp_id,
                            name: therap.name
                        };
                    }
                    return null;
                };
                addToFormArr('employee', currentEmployee());
            }

            setEmpLoading(false);
        } catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.location, values.service]);

    const fetchPatData = useCallback(async () => {
        if (!values.location?.id || !values.service?.id) {
            return;
        }
        try {
            const res = await axios.post(
                `${API_ENDPOINT}/api/scheduler/patient-list/`,
                {
                    filters: {
                        locations: [values.location.id],
                        services: [values.service.id],
                        client_id: user?.client_id
                    }
                },
                {
                    headers: {
                        SUBTYPE: 'LIST',
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            setPatients(transformData(res.data.fields, 'name', 'pat_id', patientNameOrderValueGetter));

            setPatLoading(false);
        } catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.location, values.service]);

    /**
     * * FUNCTION : Utils
     */
    const handleEditClick = () => {
        setIsView((isView) => !isView);
    };

    const handleEditEventClick = () => {
        if (scheduleData?.patients?.some((patient) => patient.is_active === false)) {
            notify({
                message: 'Patient is inactive',
                severity: 'warning'
            });
            return;
        }
        setIsView((isView) => !isView);
    };

    const handleOpenDelete = () => {
        setShowDelete(true);
    };

    const handleCloseDelete = () => {
        setShowDelete(false);
        setEditParent('');
        setFieldValue('event_nature', '');
    };
    const [checkPermission, { isLoading: isPermissionChecking }] = useCheckPermissionMutation();

    const [openValidation, setValidationOpen] = useState(false);
    const [validationResp, setValidationResp] = useState([]);

    const handleValidationClose = () => {
        setValidationOpen(false);
    };

    const handleStartEvaluation = async () => {
        try {
            if (!scheduleData?.patients?.[0]?.is_active) {
                notify({
                    message: 'Patient is inactive',
                    severity: 'warning'
                });
            } else {
                if (scheduleData.visit_type === 'EVALUATION') {
                    if (scheduleData.therapy.evaluation) {
                        navigate(
                            `/therapy/${scheduleData.services[0]?.service_code.toLowerCase()}/evaluation/edit/${encriptId(
                                scheduleData.therapy.evaluation
                            )}`
                        );
                    } else {
                        if (!isSuperAdmin) {
                            await checkPermission({
                                employee_id: user?.emp_id,
                                client_id: user?.client_id,
                                is_evaluation: 1,
                                source: 'therapy'
                            }).unwrap();
                        }
                        navigate(`/therapy/evaluation/create/schedule/${encriptId(scheduleData.sch_id)}`);
                    }
                }
                if (scheduleData.visit_type === 'TREATMENT') {
                    if (scheduleData.therapy.treatment) {
                        navigate(
                            `/therapy/${scheduleData.services[0]?.service_code.toLowerCase()}/treatment/edit/${encriptId(
                                scheduleData.therapy.treatment
                            )}`
                        );
                    } else {
                        if (!isSuperAdmin) {
                            await checkPermission({
                                employee_id: user?.emp_id,
                                client_id: user?.client_id,
                                is_evaluation: 0,
                                source: 'therapy'
                            }).unwrap();
                        }
                        navigate(`/therapy/treatment/create/schedule/${encriptId(scheduleData.sch_id)}`);
                    }
                }
            }
            setValidationResp([]);
        } catch (error) {
            setValidationOpen(true);
            setValidationResp(error?.data?.message || []);
        }
    };

    const handleTreatmentTypeChange = (e, v) => {
        addToForm('treatment_type', v);
        if (v === 'individual') {
            // addToFormArr('patients', []);
        } else if (v === 'group') {
            // addToForm('patient', null);
        }
    };

    /**
     * * FUNCTION : SIDE EFFECTS
     */
    useEffect(() => {
        if (scheduleDetail) {
            setScheduleData(scheduleDetail.fields);
        }
    }, [scheduleDetail]);

    useEffect(() => {
        formik.setValues(getInitialValues(scheduleData, range));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scheduleData]);

    useEffect(() => {
        if (!locations) {
            fetchLocData();
        }

        if (didLocChange) {
            setFieldValue('service', null);
            setFieldValue('employee', []);
            setFieldValue('patient', []);
        }
        setDidLocChange(false);
    }, [fetchLocData, locations, setFieldValue, didLocChange, setDidLocChange]);

    useEffect(() => {
        if (serviceData) {
            setServices(
                serviceData.fields
                    ?.filter((item) =>
                        hasPermission([`${item?.service_code?.toLowerCase()}_eval_add`, `${item?.service_code?.toLowerCase()}_note_add`])
                    )
                    .map((item) => ({
                        ...item,
                        id: item?.id
                    }))
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceData]);

    useEffect(() => {
        if (values.location?.id) {
            fetchEmpData();
        }
    }, [values.location, fetchEmpData]);

    useEffect(() => {
        if (values.location?.id || values.service?.id) {
            fetchPatData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.location, fetchPatData]);

    useEffect(() => {
        if (tableEdit) {
            setIsView((isView) => !isView);
        }
    }, [tableEdit]);

    useEffect(() => {
        if (formik.values.start) {
            formik.setFieldValue('days', [moment(new Date(formik.values.start)).weekday() - 1]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.start]);

    // console.log('formik::', formik);

    const handleChangeRecurring = (event, value) => {
        // setRecurring(value);
        if (value) {
            formik.setFieldValue('eventType', value);
        }
    };

    const handleChangeEnd = (event) => {
        setFieldValue('rec_end_type', event.target.value);
        // setEndValue(event.target.value);
    };

    useEffect(() => {
        if (formik?.values?.visitType && !event) {
            if (formik?.values?.visitType === 'TREATMENT') {
                addToFormArr('grp_patients', []);
                addToForm('patient', null);
            } else {
                addToForm('patient', null);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.visitType]);

    useEffect(() => {
        // if (event) {
        if (formik?.values?.treatment_type === 'individual') {
            // addToForm('patients', null);
        } else {
            // addToForm('patient', null);
        }
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.treatment_type]);

    const handlePatientChangeV2 = (v, reason, formik, selectedIds, setSelectedIds) => {
        let removedItem;

        if (reason === 'removeOption') {
            // Find the removed item
            removedItem = selectedIds.find((location) => !v.some((newLocation) => newLocation.id === location));

            // Update Formik's locations field to exclude the removed item
            formik.setFieldValue(
                'grp_patients',
                v.filter((item) => item?.id !== removedItem)
            );
        } else {
            // Get the patientIds from the 'v' array
            const patientIds = v.map((option) => option?.id);

            // Count occurrences of each location.id
            // Count occurrences of each patientId
            const patientCount = patientIds.reduce((acc, id) => {
                acc[id] = (acc[id] || 0) + 1; // Increment the count for each patientId
                return acc;
            }, {});

            // Filter out location ids that appear more than once
            const duplicatePatientIds = Object.keys(patientCount).filter((id) => patientCount[id] > 1);

            // Remove duplicate locations
            const filteredV = v.filter((option) => !duplicatePatientIds.includes(String(option?.id)));

            // Update the selectedIds state (keeping track of previously selected IDs)
            setSelectedIds((prevIds) => [...prevIds, ...filteredV.filter((id) => !prevIds.includes(id))]);

            // Update Formik's locations field with the filtered locations
            formik.setFieldValue('grp_patients', filteredV);
        }
    };

    const toggleDay = (dayId) => {
        const current = values.weekDays || [];
        const updated = current.includes(dayId) ? current.filter((id) => id !== dayId) : [...current, dayId];

        setFieldValue('weekDays', updated);
    };

    const dayOfMonth = values?.start?.date(); // e.g., 12
    const weekday = values?.start?.format('dddd'); // e.g., Sunday

    const getWeekOfMonth = (date) => {
        const startOfMonth = date?.clone().startOf('month');
        const adjustedDate = date?.date() + startOfMonth.day();
        return Math.ceil(adjustedDate / 7);
    };

    const getOrdinalWeekdayInMonthSuffix = (date) => {
        if (!date || !date.isValid()) return null;

        const weekdayName = date.format('dddd');
        const dayOfMonth = date.date();
        const firstDayOfMonth = date.clone().startOf('month');

        // Count how many times this weekday has occurred in the month up to this date
        let occurrence = 0;
        for (let day = 1; day <= dayOfMonth; day++) {
            if (firstDayOfMonth.clone().date(day).day() === date.day()) {
                occurrence++;
            }
        }

        // Get the ordinal suffix
        let suffix;
        if (occurrence % 100 >= 11 && occurrence % 100 <= 13) {
            suffix = 'th';
        } else {
            switch (occurrence % 10) {
                case 1:
                    suffix = 'st';
                    break;
                case 2:
                    suffix = 'nd';
                    break;
                case 3:
                    suffix = 'rd';
                    break;
                default:
                    suffix = 'th';
            }
        }

        // console.log('ordinal::', `${occurrence}${suffix} ${weekdayName}`);

        return `${occurrence}${suffix}`;
    };

    const getOrdinalWeekdayInMonth = (date) => {
        if (!date || !date.isValid()) return null;

        const weekdayName = date.format('dddd');
        const dayOfMonth = date.date();
        const firstDayOfMonth = date.clone().startOf('month');

        // Count how many times this weekday has occurred in the month up to this date
        let occurrence = 0;
        for (let day = 1; day <= dayOfMonth; day++) {
            if (firstDayOfMonth.clone().date(day).day() === date.day()) {
                occurrence++;
            }
        }

        return occurrence;
    };
    const weekOrdinalMonth = values?.start ? getOrdinalWeekdayInMonthSuffix(values?.start) : null; // e.g., 2
    const weekOfMonth = values?.start ? getOrdinalWeekdayInMonth(values?.start) : null; // e.g., 2
    // console.log('scheduleDataObject 0::', scheduleData);
    const scheduleDataObject = {
        locationId: scheduleData?.locations?.[0]?.id ?? null,
        serviceId: scheduleData?.services?.[0]?.id ?? null,
        visitType: scheduleData?.visit_type ?? null,
        employeeId: scheduleData?.employees?.[0]?.id ?? null,
        patientId: !scheduleData?.is_grouped ? scheduleData?.patients?.[0]?.id : null,
        treatmentType: scheduleData?.is_grouped ? 'group' : 'individual',
        start: scheduleData?.start_date_time ?? null,
        startDate: scheduleData?.start_date_time ? (scheduleData?.start_date_time ?? '').split(' ')?.[0] : null,
        startTime: scheduleData?.start_date_time ? (scheduleData?.start_date_time ?? '').split(' ')?.[1] : null,
        description: scheduleData?.description ?? null, // Assuming an empty string as per your log
        durationHour: scheduleData?.duration_hour ?? null,
        durationMinute: scheduleData?.duration_minute ?? null,

        eventType: scheduleData?.group_schedule?.occurence.toLowerCase() ?? null,
        noOfOccurence: scheduleData?.group_schedule?.no_of_occurence ?? null,
        endDateTime: scheduleData?.group_schedule?.end_date
            ? moment(new Date(scheduleData?.group_schedule?.end_date)).utc().format('YYYY-MM-DD HH:mm:ss')
            : null,
        weekDays: scheduleData?.group_schedule?.weekly_repeat_type
            ? JSON.parse(scheduleData.group_schedule.weekly_repeat_type).length > 0
                ? JSON.stringify(JSON.parse(scheduleData.group_schedule.weekly_repeat_type))
                : null
            : null,
        group_patientId: scheduleData?.is_grouped ? scheduleData?.patients?.map((item) => item?.id) : [],
        monthly_rec_type:
            scheduleData?.group_schedule?.monthly_repeat_type === 'DAY'
                ? 'dayOfMonth'
                : scheduleData?.group_schedule?.monthly_repeat_type === 'WEEKDAY'
                  ? 'weekdayOfMonth'
                  : ''
    };
    // console.log('scheduleDataObject::', scheduleDataObject);

    const valuesObject = {
        locationId: values?.location?.id ?? null,
        serviceId: values?.service?.id ?? null,
        visitType: values?.visitType ?? null,
        employeeId: values?.employee?.id ?? null,
        patientId: values?.patient?.id ?? null,
        treatmentType: values?.treatment_type ?? null,
        start: values?.start ? moment(new Date(values.start)).utc().format('YYYY-MM-DD HH:mm:ss') : null,
        startDate: values?.start ? (moment(new Date(values.start)).utc().format('YYYY-MM-DD HH:mm:ss') ?? '').split(' ')?.[0] : null,
        startTime: values?.start ? (moment(new Date(values.start)).utc().format('YYYY-MM-DD HH:mm:ss') ?? '').split(' ')?.[1] : null,
        description: values?.description ?? null,
        durationHour: values?.hour ?? null,
        durationMinute: values?.minute ?? null,
        eventType: values?.eventType ?? null,
        noOfOccurence: values?.noOfOccurence ?? null,
        endDateTime: values?.endDateTime ? moment(new Date(values?.endDateTime)).utc().format('YYYY-MM-DD HH:mm:ss') : null,
        weekDays: Array.isArray(values?.weekDays) && values?.weekDays.length > 0 ? JSON.stringify(values?.weekDays) : null,
        monthly_rec_type: values?.monthly_rec_type ?? null,
        group_patientId: values?.grp_patients?.map((item) => item?.id)
    };
    // console.log('scheduleDataObject 2 ::', valuesObject);

    const deleteMessage = () => {
        if (values.event_nature === 'this-event') {
            return 'this event';
        }
        if (values.event_nature === 'upcoming-events') {
            return 'This and following events';
        }
        if (values.event_nature === 'all-events') {
            return 'All events';
        }
        return 'this event';
    };

    function compareObjects(obj1 = {}, obj2 = {}) {
        const changes = {};

        const arraysEqual = (a, b) => {
            if (!Array.isArray(a) || !Array.isArray(b)) return false;
            if (a.length !== b.length) return false;
            return a.every((val, index) => val === b[index]);
        };

        for (const key in obj1) {
            let val1 = obj1[key];
            let val2 = obj2[key];

            if (key === 'noOfOccurence') {
                if (val1 === '') val1 = null;
                if (val2 === '') val2 = null;
            }

            if (key === 'group_patientId') {
                const arr1 = Array.isArray(val1) ? val1 : [];
                const arr2 = Array.isArray(val2) ? val2 : [];

                // Compare arrays by value & order
                if (!arraysEqual(arr1, arr2)) {
                    changes[key] = { old: arr1, new: arr2 };
                }
                continue;
            }

            if (val1 !== val2) {
                changes[key] = { old: val1, new: val2 };
            }
        }
        return changes;
    }

    useEffect(() => {
        if (values.monthly_rec_type === 'weekdayOfMonth') {
            setFieldValue('monthly_rec_type', 'weekdayOfMonth');
            const day = shotDays.find((day) => day.name === weekday);
            const dayId = day?.id;
            setFieldValue('monthly_week_number', weekOfMonth);
            setFieldValue('monthly_week_day', dayId);
        } else if (values.monthly_rec_type === 'dayOfMonth') {
            setFieldValue('monthly_rec_type', 'dayOfMonth');
            setFieldValue('monthly_week_day', dayOfMonth);
        }
    }, [values.monthly_rec_type]);

    if (scheduleLoading || isPermissionChecking) {
        return <Spinner />;
    }

    return (
        <FormikProvider value={formik}>
            {values.group_schedule_id && (
                <UpdateMoal
                    updateType={updateType}
                    setFieldValue={setFieldValue}
                    setUpdateType={setUpdateType}
                    values={values}
                    setShowDelete={setShowDelete}
                    editParent={editParent}
                />
            )}

            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                {(serviceLoading || addLoading || updateLoading || addCreateLoading) && <Spinner />}
                {isView ? (
                    <DialogTitle sx={{ pr: 6 }}>
                        {values?.is_grouped
                            ? `Group Treatment for ${values.grp_patients.map((item) => item.user.name).join(', ')}${scheduleData?.missed_reason ? ' (Missed Note)' : ''}`
                            : values.title + (scheduleData?.missed_reason ? ' (Missed Note)' : '')}

                        {/* {values.is_grouped ? 'Group ' : ''} {values.title} {scheduleData?.missed_reason && '(Missed Note)'} */}
                    </DialogTitle>
                ) : (
                    <DialogTitle sx={{ pr: 6 }}>{scheduleData ? 'Edit Event' : 'Add Event'}</DialogTitle>
                )}
                <Divider />
                <DialogContent sx={{ p: 3 }}>
                    <IconButton onClick={onCancel} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                        <Close />
                    </IconButton>
                    {isView && (
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12} md={6}>
                                <Stack
                                    direction="row"
                                    justifyContent="flex-start;"
                                    alignItems="center"
                                    // divider={<Divider sx={{ color: 'black', fontSize: '1.4rem', fontWeight: 700 }}>:</Divider>}
                                >
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Patient
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>
                                    <div style={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}>
                                        <Typography varient="h4" component="h4">
                                            {values?.is_grouped
                                                ? values.grp_patients?.map((pat) => pat.user.name).join(', ')
                                                : values.patient?.name}
                                        </Typography>
                                    </div>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Location
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography
                                        varient="h4"
                                        component="h4"
                                        sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                    >
                                        {values.location?.name}
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Employee
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>
                                    <div style={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}>
                                        <Typography varient="h4" component="h4">
                                            {getEmployeeName(values.employee)}
                                        </Typography>
                                    </div>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Service
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography
                                        varient="h4"
                                        component="h4"
                                        sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                    >
                                        {values.service?.service_name}
                                    </Typography>
                                </Stack>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Visit Type
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography
                                        varient="h4"
                                        component="h4"
                                        sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                    >
                                        {values.visitType}
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Status
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography varient="h4" component="h4" sx={{ minWidth: '150px', margin: '0px 10px' }}>
                                        {values.status}
                                    </Typography>
                                </Stack>
                            </Grid>
                            {values.is_grouped === false && (
                                <Grid item xs={12}>
                                    <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                        <Typography
                                            variant="h4"
                                            component="h4"
                                            sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}
                                        >
                                            Special needs
                                        </Typography>

                                        <Typography variant="h4" component="h4" ml={4} sx={{ minWidth: '10px', marginLeft: '0px' }}>
                                            :
                                        </Typography>

                                        <Typography
                                            ml="10px"
                                            varient="h4"
                                            component="h4"
                                            sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                        >
                                            {values.description}
                                        </Typography>
                                    </Stack>
                                </Grid>
                            )}
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Start Time
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography
                                        varient="h4"
                                        component="h4"
                                        sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                    >
                                        {moment(values.start)?.format(`${GLOBAL_DATE_FORMAT} - hh:mm a`)}
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" justifyContent="flex-start;" alignItems="center">
                                    <Typography variant="h4" component="h4" sx={{ minWidth: '120px', maxWidth: '150px', width: 'auto' }}>
                                        Duration
                                    </Typography>

                                    <Typography variant="h4" component="h4" sx={{ minWidth: '10px' }}>
                                        :
                                    </Typography>

                                    <Typography
                                        varient="h4"
                                        component="h4"
                                        sx={{ minWidth: '150px', maxWidth: '250px', width: 'auto', margin: '0px 10px' }}
                                    >
                                        {values.hour} hrs and {values.minute} min.
                                    </Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    )}
                    {!isView && (
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        fullWidth
                                        value={values.location}
                                        onChange={(_, value) => {
                                            addToForm('location', value ? { id: value.id, name: value.name } : {});
                                            setDidLocChange(true);
                                        }}
                                        options={locations || []}
                                        disableClearable
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        loading={locLoading}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                error={Boolean(errors.location) && touched.location}
                                                onBlur={handleBlur}
                                                name="location"
                                                label="Location *"
                                                helperText={touched.location && errors.location}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        fullWidth
                                        onChange={(_, value) => {
                                            addToForm('service', value);
                                        }}
                                        options={services || []}
                                        disabled={Boolean(!values.location)}
                                        loading={serviceLoading}
                                        getOptionLabel={(option) => option.service_name}
                                        value={values.service}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField
                                                error={Boolean(errors.service) && touched.service}
                                                {...params}
                                                label="Service *"
                                                name="service"
                                                onBlur={handleBlur}
                                                helperText={touched.service && errors.service && (errors.service.name || errors.service)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl error={Boolean(errors.visitType) && touched.visitType} fullWidth>
                                    <InputLabel id="visitType-label">Visit Type *</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="visitType-label"
                                        id="visitType"
                                        disabled={Boolean(!values.location)}
                                        {...getFieldProps('visitType')}
                                        name="visitType"
                                        onBlur={handleBlur('visitType')}
                                        onChange={(e, v) => {
                                            addToForm('visitType', e.target.value);
                                        }}
                                        label="Visit Type *"
                                    >
                                        {visitValues.map((type, index) => (
                                            <MenuItem value={type.value} key={index}>
                                                {type.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {touched.visitType && Boolean(errors.visitType) && <FormHelperText>{errors.visitType}</FormHelperText>}
                                </FormControl>
                            </Grid>

                            <Grid item md={6}>
                                <Typography variant="h2" component="h2" sx={{ fontWeight: 500, fontSize: '1.25rem' }}>
                                    Participants
                                </Typography>
                            </Grid>

                            <Grid item md={5}>
                                {values.visitType === 'TREATMENT' && (
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={values.treatment_type}
                                        exclusive
                                        onChange={(e, v) => {
                                            if (v !== null) {
                                                handleTreatmentTypeChange(e, v);
                                                setAnchorEl(null);
                                            }
                                        }}
                                        aria-label="treatment_type"
                                    >
                                        <ToggleButton value="individual">Individual</ToggleButton>
                                        <ToggleButton value="group">Group</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            </Grid>

                            <Grid item md={1}>
                                {((values?.treatment_type === 'group' && values?.grp_patients?.length > 0) ||
                                    (values?.treatment_type !== 'group' && values?.patient?.id && values?.patient?.preference)) && (
                                    <Tooltip title="Patient preferences" arrow>
                                        <IconButton
                                            sx={{
                                                transition: 'transform 0.3s ease, opacity 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.2)'
                                                }
                                            }}
                                            ref={anchorRef}
                                            onClick={async (event) => {
                                                let patientList = [];
                                                if (!anchorEl) {
                                                    if (
                                                        values.treatment_type === 'group' &&
                                                        values.visitType === 'TREATMENT' &&
                                                        values.grp_patients?.length
                                                    ) {
                                                        patientList = values.grp_patients?.map((item) => item.id);
                                                    } else if (values.treatment_type === 'individual' && values.patient?.id) {
                                                        patientList = [values.patient.id];
                                                    }
                                                }

                                                setAnchorEl(anchorEl ? null : event.currentTarget);
                                                if (patientList.length) {
                                                    await getPreferences(
                                                        payloadToFormData({
                                                            patient_id: JSON.stringify(patientList)
                                                        })
                                                    );
                                                }
                                            }}
                                        >
                                            <InfoOutlinedIcon
                                                sx={{
                                                    mt: 0.5,
                                                    animation: shouldAnimate ? `${heartbeat} 2s ease` : 'none'
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Popper
                                    placement="top-start"
                                    open={popperOpen}
                                    anchorEl={anchorEl}
                                    disablePortal
                                    style={{ width: 400, zIndex: 18 }}
                                >
                                    <Paper elevation={8} sx={{ padding: 1 }}>
                                        <Box>
                                            <Stack direction="row" justifyContent="space-between" sx={{ mb: 2, mt: 1 }}>
                                                <Typography align="left" component="h1" sx={{ fontSize: 16, fontWeight: 450 }}>
                                                    Patient Preference
                                                </Typography>
                                                <IconButton sx={{ p: 0 }} onClick={() => setAnchorEl(null)} size="large">
                                                    <CloseIcon color="primary" />
                                                </IconButton>
                                            </Stack>

                                            {preferenceLoading || preferenceFetching ? (
                                                // Shimmer Loading
                                                Array.from({ length: 1 }).map((_, index) => (
                                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }} key={index}>
                                                        <Skeleton variant="circular" width={35} height={35} />
                                                        <Stack spacing={1} flex={1}>
                                                            <Skeleton width="80%" height={20} />
                                                            <Skeleton width="60%" height={20} />
                                                        </Stack>
                                                    </Stack>
                                                ))
                                            ) : preferenceList?.fields?.length > 0 ? (
                                                // Preference List
                                                preferenceList.fields.map((item) => {
                                                    const fromTime =
                                                        item?.start_time && moment.utc(item?.start_time).local().format('hh:mm A');

                                                    const toTime = item?.end_time && moment.utc(item?.end_time).local().format('hh:mm A');

                                                    return (
                                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }} key={item.id}>
                                                            <Avatar sx={{ width: 35, height: 35 }}>
                                                                {' '}
                                                                {item.patient_name?.charAt(0).toUpperCase()}
                                                            </Avatar>
                                                            <Stack direction="column" justifyContent="center">
                                                                <Typography align="left" component="span">
                                                                    <strong>{item.patient_name}</strong>:{' '}
                                                                    {item?.patient_preference_days
                                                                        ?.filter((day) => day.is_active)
                                                                        .sort((a, b) => {
                                                                            const dayOrder = [
                                                                                'Sunday',
                                                                                'Monday',
                                                                                'Tuesday',
                                                                                'Wednesday',
                                                                                'Thursday',
                                                                                'Friday',
                                                                                'Saturday'
                                                                            ];
                                                                            return (
                                                                                dayOrder.indexOf(a.day_display) -
                                                                                dayOrder.indexOf(b.day_display)
                                                                            );
                                                                        })
                                                                        .map((day) => day.day_display)
                                                                        .join(', ')}{' '}
                                                                    {fromTime && toTime && ` ( ${fromTime} to ${toTime} )`}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    );
                                                })
                                            ) : (
                                                // No Data Message
                                                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2, mb: 2 }}>
                                                    No data available.
                                                </Typography>
                                            )}
                                        </Box>
                                    </Paper>
                                </Popper>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        disabled={isTherapist || Boolean(!values.location || !values.service)}
                                        fullWidth
                                        onChange={(e, value) => {
                                            addToForm(
                                                'employee',
                                                value
                                                    ? {
                                                          id: value.emp_id,
                                                          name: value.name,
                                                          credentials: value.credentials || ''
                                                      }
                                                    : null
                                            );
                                        }}
                                        options={employees || []}
                                        value={values.employee}
                                        loading={empLoading}
                                        getOptionLabel={(option) => getEmployeeName(option)}
                                        isOptionEqualToValue={(option, value) => option.emp_id === value.id}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option?.emp_id}>
                                                {getEmployeeName(option)}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                error={touched.employee && Boolean(errors.employee)}
                                                {...params}
                                                label="Employee *"
                                                onBlur={handleBlur}
                                                helperText={touched.employee && errors.employee}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            {values.treatment_type === 'group' && values.visitType === 'TREATMENT' ? (
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <PatientDropdown
                                            required
                                            limitTags={2}
                                            async
                                            multiple
                                            value={values?.grp_patients ?? []}
                                            payload={{
                                                payer_category: 1,
                                                services: [values?.service?.id],
                                                location: [values?.location?.id]
                                            }}
                                            // for handling duplication
                                            onChange={(v, reason) => {
                                                const lastSelected = Array.isArray(v) && v.length > 0 ? v[v.length - 1] : null;
                                                if (reason !== 'removeOption' && lastSelected?.is_preference) {
                                                    setShouldAnimate(true); // Trigger animation
                                                    setTimeout(() => setShouldAnimate(false), 3000); // Stop animation after 3s
                                                }
                                                handlePatientChangeV2(v, reason, formik, selectedIds, setSelectedIds);
                                                setAnchorEl(null);
                                            }}
                                            error={formik.touched.grp_patients && Boolean(formik.errors.grp_patients)}
                                            helperText={formik.touched.grp_patients && formik.errors.grp_patients}
                                        />
                                    </FormControl>
                                </Grid>
                            ) : (
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            fullWidth
                                            id="fixed-tags-demo"
                                            onChange={(_, value) => {
                                                addToForm('patient', value);
                                                if (value?.preference) {
                                                    setShouldAnimate(true); // Trigger animation
                                                    setTimeout(() => setShouldAnimate(false), 3000); // Stop animation after 3s
                                                }

                                                setAnchorEl(null);
                                            }}
                                            loading={patLoading}
                                            disabled={Boolean(!values.location)}
                                            options={patients || []}
                                            value={values.patient}
                                            getOptionLabel={(option) => option?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField
                                                    error={touched.patient && Boolean(errors.patient)}
                                                    {...params}
                                                    label="Patient *"
                                                    onBlur={handleBlur}
                                                    helperText={touched.patient && errors.patient}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}

                            {values.treatment_type === 'individual' && (
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Special needs"
                                        {...getFieldProps('description')}
                                        disabled={Boolean(!values.location)}
                                        error={Boolean(touched.description && errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} md={6}>
                                <DateTimePicker
                                    disabled={Boolean(!values.location)}
                                    // minTime={dayjs().set('hour', 5).set('minute', 59)}
                                    // maxTime={dayjs().set('hour', 22).set('minute', 59)}
                                    minTime={THERAPY_MIN_TIME}
                                    maxTime={THERAPY_MAX_TIME}
                                    label="Start date *"
                                    value={values.start}
                                    onChange={(date) => {
                                        setFieldValue('start', date);
                                        if (values.eventType === 'monthly') {
                                            const startTime = date
                                                ? (moment(new Date(date)).utc().format('YYYY-MM-DD HH:mm:ss') ?? '').split(' ')?.[1]
                                                : null;
                                            const startDate = date
                                                ? (moment(new Date(date)).utc().format('YYYY-MM-DD HH:mm:ss') ?? '').split(' ')?.[0]
                                                : null;
                                            const updatedValues = {
                                                ...valuesObject,
                                                startDate,
                                                startTime
                                            };
                                            const diffs = compareObjects(scheduleDataObject, updatedValues);
                                            let isStartDateChange = false;
                                            if (diffs.hasOwnProperty('startDate')) {
                                                isStartDateChange = true;
                                            }
                                            if (scheduleData && isStartDateChange) {
                                                setFieldValue('monthly_rec_type', '');
                                            }
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={formik.touched.start && Boolean(formik.errors.start)}
                                            helperText={formik.touched.start && formik.errors.start}
                                        />
                                    )}
                                    slotProps={{ popper: { placement: 'top-start' } }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid container gap={1}>
                                    <Grid item xs={12} md={5}>
                                        <FormControl error={touched.hour && Boolean(errors.hour)} fullWidth>
                                            <InputLabel id="hours-label">Hour</InputLabel>
                                            <Select
                                                fullWidth
                                                labelId="hours-label"
                                                id="hour"
                                                // value={values.visitType}
                                                // onChange={handleChange}
                                                {...getFieldProps('hour')}
                                                label="Hour"
                                                disabled={Boolean(!values.location)}
                                            >
                                                {hours.map((type, index) => (
                                                    <MenuItem value={type.value} key={index}>
                                                        {type.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.hour && Boolean(errors.hour) && <FormHelperText>{errors.hour}</FormHelperText>}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={5}>
                                        <FormControl error={touched.minute && Boolean(errors.minute)} fullWidth>
                                            <InputLabel id="minute-label">Minute</InputLabel>
                                            <Select
                                                fullWidth
                                                labelId="minute-label"
                                                id="minute"
                                                {...getFieldProps('minute')}
                                                label="Minute"
                                                disabled={Boolean(!values.location)}
                                            >
                                                {minute.map((type, index) => (
                                                    <MenuItem value={type.value} key={index}>
                                                        {type.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.minute && Boolean(errors.minute) && <FormHelperText>{errors.minute}</FormHelperText>}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Grid item xs={12} md={5}>
                                    <FormControl error={Boolean(errors.groupSchedule)} fullWidth>
                                        <InputLabel id="recurrence-label">Recurrence</InputLabel>
                                        <Select
                                            required
                                            fullWidth
                                            disabled={scheduleData?.status === 'SCHEDULED' || Boolean(!values.location) || !values.start}
                                            labelId="recurrence-label"
                                            id="recurrence"
                                            value={values.groupSchedule}
                                            onChange={(event, value) => {
                                                setFieldValue('groupSchedule', event.target.value);
                                            }}
                                            label="Recurrence"
                                        >
                                            <MenuItem value="0" key={0}>
                                                Does not repeat
                                            </MenuItem>
                                            <MenuItem value="1" key={1}>
                                                Custom
                                            </MenuItem>
                                        </Select>
                                        {Boolean(errors.groupSchedule) && <FormHelperText>{errors.groupSchedule}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                                <Grid container spacing={2}>
                                    {values.groupSchedule == '1' && (
                                        // ![0, 6].some((day) => moment(new Date(formik.values.start)).weekday() === day) &&
                                        <Grid item xs={12} md={12}>
                                            <Stack flexDirection="row" justifyContent="flex-start">
                                                <Grid>
                                                    <ToggleButtonGroup
                                                        color="info"
                                                        value={values.eventType}
                                                        exclusive
                                                        onChange={handleChangeRecurring}
                                                        aria-label="text alignment"
                                                        sx={{
                                                            mt: 2.5,
                                                            '& .Mui-selected': {
                                                                color: '#fff !important',
                                                                backgroundColor: '#1B357C !important',
                                                                borderColor: '#1B357C !important'
                                                            }
                                                        }}
                                                    >
                                                        <ToggleButton value="daily">Daily</ToggleButton>
                                                        <ToggleButton value="weekly">Weekly</ToggleButton>
                                                        <ToggleButton value="monthly">Monthly</ToggleButton>
                                                        <ToggleButton value="yearly">Annually</ToggleButton>
                                                    </ToggleButtonGroup>
                                                    <FormHelperText sx={{ mt: 1 }} error={touched.eventType && Boolean(errors.eventType)}>
                                                        {touched.eventType && errors.eventType}
                                                    </FormHelperText>
                                                    {values.eventType === 'weekly' && (
                                                        <Grid item xs={12} md={6}>
                                                            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                                                                {shotDays.map((day) => {
                                                                    const isSelected = values.weekDays?.includes(day.id);
                                                                    return (
                                                                        <Chip
                                                                            key={day.id}
                                                                            label={day.label}
                                                                            onClick={() => toggleDay(day.id)}
                                                                            variant={isSelected ? 'filled' : 'outlined'}
                                                                            color={isSelected ? 'primary' : 'default'}
                                                                        />
                                                                    );
                                                                })}
                                                            </Stack>
                                                            <FormHelperText
                                                                sx={{ mt: 1 }}
                                                                error={touched.weekDays && Boolean(errors.weekDays)}
                                                            >
                                                                {touched.weekDays && errors.weekDays}
                                                            </FormHelperText>
                                                        </Grid>
                                                    )}
                                                    {values.eventType === 'monthly' && (
                                                        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                                                            <FormControl fullWidth>
                                                                <InputLabel id="recurrence-label">Repeat on</InputLabel>
                                                                <Select
                                                                    required
                                                                    fullWidth
                                                                    labelId="repeat-label"
                                                                    id="repeat"
                                                                    value={values.monthly_rec_type}
                                                                    onChange={(event, value) => {
                                                                        if (event.target.value === 'weekdayOfMonth') {
                                                                            setFieldValue('monthly_rec_type', 'weekdayOfMonth');
                                                                            const day = shotDays.find((day) => day.name === weekday);
                                                                            const dayId = day?.id;
                                                                            setFieldValue('monthly_week_number', weekOfMonth);
                                                                            // setFieldValue('monthly_week_day', weekday);
                                                                            setFieldValue('monthly_week_day', dayId);
                                                                        } else {
                                                                            // const day = shotDays.find((day) => day.name === weekday);
                                                                            // const dayId = day?.id;
                                                                            setFieldValue('monthly_rec_type', 'dayOfMonth');
                                                                            setFieldValue('monthly_week_day', dayOfMonth);
                                                                        }
                                                                    }}
                                                                    label="Repeat on"
                                                                >
                                                                    <MenuItem value="dayOfMonth">{`Day ${dayOfMonth} of every month`}</MenuItem>
                                                                    <MenuItem value="weekdayOfMonth">
                                                                        {`${weekOrdinalMonth} ${weekday} of every month`}
                                                                    </MenuItem>
                                                                </Select>
                                                                {Boolean(errors.monthly_rec_type) && (
                                                                    <FormHelperText error={Boolean(errors.monthly_rec_type)}>
                                                                        {errors.monthly_rec_type}
                                                                    </FormHelperText>
                                                                )}
                                                            </FormControl>
                                                        </Grid>
                                                    )}
                                                </Grid>

                                                <Stack
                                                    flexDirection="column"
                                                    sx={{
                                                        ml: 12
                                                    }}
                                                >
                                                    <FormControl sx={{ mt: 2 }} error={Boolean(errors.rec_end_type)}>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                                            name="controlled-radio-buttons-group"
                                                            value={values.rec_end_type}
                                                            onChange={handleChangeEnd}
                                                        >
                                                            <FormControlLabel
                                                                value="no_of_occurances"
                                                                control={<Radio />}
                                                                label="Number  of Occurrences"
                                                            />
                                                            <FormControlLabel value="end_date" control={<Radio />} label="End Date" />
                                                        </RadioGroup>
                                                        {Boolean(errors.rec_end_type) && (
                                                            <FormHelperText>{errors.rec_end_type}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                    {values.rec_end_type === 'no_of_occurances' ? (
                                                        <TextField
                                                            required
                                                            id="outlined-number"
                                                            label="Count"
                                                            type="number"
                                                            value={values.noOfOccurence || ''}
                                                            inputProps={{
                                                                min: 1, // set your min value here
                                                                max: 99 // set your max value here
                                                            }}
                                                            onChange={(e, v) => {
                                                                setFieldValue('noOfOccurence', e.target.value);
                                                            }}
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            sx={{ mt: 2 }}
                                                            error={touched.noOfOccurence && Boolean(errors.noOfOccurence)}
                                                            helperText={touched.noOfOccurence && errors.noOfOccurence}
                                                        />
                                                    ) : values.rec_end_type === 'end_date' ? (
                                                        <DatePicker
                                                            required
                                                            inputFormat={GLOBAL_DATE_FORMAT}
                                                            minDate={values.start}
                                                            // maxDate={moment(values.start).add(99, 'days').toDate()}
                                                            value={values.endDateTime}
                                                            onChange={(date) => setFieldValue('endDateTime', date)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={formik.touched.endDateTime && Boolean(formik.errors.endDateTime)}
                                                                    helperText={formik.touched.endDateTime && formik.errors.endDateTime}
                                                                />
                                                            )}
                                                        />
                                                    ) : null}
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            {/* if Custom */}
                        </Grid>
                    )}
                </DialogContent>

                <DialogActions sx={{ p: 3 }}>
                    {isView && !isViewOnly && (
                        <>
                            <Grid item>
                                {(hasPermission(['therapy_appointments_delete']) ||
                                    values.employee?.id === user?.emp_id ||
                                    user.supervisee?.includes(values.employee?.id)) &&
                                    !table &&
                                    scheduleData?.status === 'SCHEDULED' && (
                                        <Tooltip title="Delete Event">
                                            <IconButton
                                                onClick={() => {
                                                    if (values.group_schedule_id && !values.event_nature) {
                                                        setEditParent('delete');
                                                        setUpdateType(true);
                                                    } else {
                                                        handleOpenDelete();
                                                    }
                                                }}
                                                size="large"
                                            >
                                                <DeleteIcon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                            </Grid>
                            {!scheduleData?.missed_reason && (
                                <Grid item>
                                    {(hasPermission(['therapy_appointments_edit']) ||
                                        values.employee?.id === user?.emp_id ||
                                        user.supervisee?.includes(values.employee?.id)) &&
                                        !table &&
                                        scheduleData?.status === 'SCHEDULED' && (
                                            <Tooltip title="Edit Event">
                                                <IconButton onClick={handleEditEventClick} size="large">
                                                    <Edit color="primary" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                </Grid>
                            )}
                            {!scheduleData?.missed_reason && (
                                <Grid item>
                                    {(hasPermission([`${scheduleData?.services[0]?.service_code.toLowerCase()}_eval_edit`]) ||
                                        values.employee?.id === user?.emp_id ||
                                        user.supervisee?.includes(values.employee?.id)) &&
                                        scheduleData?.status === 'SCHEDULED' &&
                                        (scheduleData?.visit_type === 'EVALUATION' || scheduleData?.visit_type === 'TREATMENT') && (
                                            <Button onClick={handleStartEvaluation} variant="contained">
                                                Start
                                            </Button>
                                        )}

                                    {!values.is_grouped &&
                                        (hasPermission([`${scheduleData?.services[0]?.service_code.toLowerCase()}_eval_edit`]) ||
                                            values.employee?.id === user?.emp_id ||
                                            user.supervisee?.includes(values.employee?.id)) &&
                                        scheduleData?.status !== 'SCHEDULED' &&
                                        (scheduleData?.visit_type === 'EVALUATION' || scheduleData?.visit_type === 'TREATMENT') && (
                                            <Button onClick={handleStartEvaluation} variant="contained">
                                                View
                                            </Button>
                                        )}
                                </Grid>
                            )}
                        </>
                    )}
                    {!isView && (
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid>
                                {!table && event && (
                                    <Button type="submit" variant="outlined" onClick={handleEditClick}>
                                        Go back
                                    </Button>
                                )}
                            </Grid>

                            <Grid item>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    {/* <Button type="submit" variant="contained" disabled={isSubmitting || Boolean(!values.location)}>
                                        {scheduleData ? 'Save' : 'Add'}
                                    </Button> */}
                                    <Button
                                        type="button" // prevent form auto-submit so you can control logic
                                        variant="contained"
                                        disabled={isSubmitting || !values.location}
                                        onClick={async () => {
                                            // for handling formik error messages
                                            if (!formik.isValid) {
                                                formik.handleSubmit();
                                                return;
                                            }

                                            // console.log('here scheduleDataObject ::', scheduleDataObject);
                                            // console.log('here valuesObject ::', valuesObject);
                                            // Compare schedule date new dats
                                            const diffs = compareObjects(scheduleDataObject, valuesObject);
                                            // console.log('diffs::', diffs);

                                            let isTreatmentDataChange = false;
                                            let isStartDateChange = false;
                                            let isStartTimeChange = false;
                                            let isRecChange = false;
                                            let isStartDateOfMonthChange = false;
                                            let isGroupChange = false;

                                            if (Object.keys(diffs).length > 0) {
                                                isTreatmentDataChange = treatmentDataKeys.some((key) => diffs.hasOwnProperty(key));
                                                if (diffs.hasOwnProperty('startDate')) {
                                                    isStartDateChange = true;
                                                    if (values.eventType === 'monthly') {
                                                        isStartDateOfMonthChange = true;
                                                    }
                                                }
                                                if (diffs.hasOwnProperty('group_patientId')) {
                                                    isGroupChange = true;
                                                }
                                                isStartTimeChange = startTimeKeys.some((key) => diffs.hasOwnProperty(key));
                                                isRecChange = recChangeKeys.some((key) => diffs.hasOwnProperty(key));
                                                setFieldValue('event_nature', '');
                                            }

                                            // handle popup logic here
                                            const isRecPopUp =
                                                (!isStartDateChange || (isStartDateChange && isStartDateOfMonthChange)) && // if only start date change -- no POPUP ||  if start date change && Monthly -- no POPUP
                                                (isTreatmentDataChange || // check if ** treatment data changed
                                                    isStartTimeChange || // check if ** treatment time changed
                                                    isGroupChange ||
                                                    (isStartDateChange && isStartDateOfMonthChange)) && // check if **  date changed for a monthly reccurence
                                                values.group_schedule_id && // Ensure its a ** RECCURRING  EVENT
                                                !values.event_nature && // Ensure ** NO POPUP SELECTED
                                                scheduleData; // Ensure its an ** EDIT

                                            const timeRecCompo = isStartTimeChange && isRecChange; // NO - POPUP
                                            const DateRecCompo = isStartDateChange && isRecChange;

                                            if (isRecPopUp && !timeRecCompo) {
                                                setUpdateType(true);
                                                setEditParent('update');
                                            } else {
                                                try {
                                                    if (values.treatment_type === 'individual' && values?.patient?.is_active === false) {
                                                        notify({
                                                            message: 'Patient is inactive',
                                                            severity: 'warning'
                                                        });
                                                        return;
                                                    }

                                                    let grpPatients = [];
                                                    if (values.treatment_type === 'group') {
                                                        grpPatients = values?.grp_patients.map((item) => {
                                                            return {
                                                                id: item.id,
                                                                name: item.user.name,
                                                                is_active: item.user.is_active
                                                            };
                                                        });
                                                    }

                                                    const payload = {
                                                        fg_color: values.textColor,
                                                        bg_color: getBg(values.service.service_name.replaceAll(' ', '').toLowerCase()),
                                                        employees: [values.employee.id],
                                                        locations: [values.location.id],
                                                        patients:
                                                            values.treatment_type === 'group'
                                                                ? grpPatients.map((item) => item.id)
                                                                : [values.patient.id],
                                                        services: [values.service.id],
                                                        // if  recurent send without conversion
                                                        start_date_time:
                                                            values.groupSchedule === '1'
                                                                ? moment(new Date(values.start)).format(PAYLOAD_DATE_TIME_FORMAT)
                                                                : moment(new Date(values.start)).utc().format(PAYLOAD_DATE_TIME_FORMAT),
                                                        ...(values.groupSchedule === '1' && { local_tz: localtimezone }),
                                                        duration_hour: values.hour,
                                                        duration_minute: values.minute,
                                                        title: makeTitle(
                                                            values.visitType,
                                                            values.treatment_type === 'group' ? grpPatients : values.patient
                                                        ),
                                                        description: values.description,
                                                        visit_type: values.visitType,

                                                        ...(!values.group_schedule_id && {
                                                            dates: values.days.map((day) =>
                                                                moment(new Date(values.start))
                                                                    .weekday(day + 1)
                                                                    .utc()
                                                                    .format(PAYLOAD_DATE_TIME_FORMAT)
                                                            )
                                                        }),
                                                        is_grouped: values.treatment_type === 'group' ? 1 : 0,

                                                        ...(values.groupSchedule === '1' && { event_type: values.eventType }),

                                                        ...(!values.group_schedule_id && {
                                                            is_group_schedule: values.groupSchedule === '1' ? true : false
                                                        }),
                                                        rec_end_type: values.rec_end_type,
                                                        ...(values.groupSchedule === '1' &&
                                                            values.rec_end_type === 'no_of_occurances' && {
                                                                no_of_occurence: values.noOfOccurence
                                                            }),
                                                        ...(values.groupSchedule === '1' &&
                                                            values.rec_end_type === 'end_date' && {
                                                                end_date_time: moment(new Date(values.endDateTime))
                                                                    .endOf('day')
                                                                    .format(PAYLOAD_DATE_TIME_FORMAT)
                                                            }),
                                                        ...(values.groupSchedule === '1' &&
                                                            values.eventType === 'weekly' && { week_days: values.weekDays }),

                                                        ...(values.groupSchedule === '1' &&
                                                            values.eventType === 'monthly' &&
                                                            values.monthly_rec_type === 'weekdayOfMonth' && {
                                                                week_day: values.monthly_week_day,
                                                                week_number: values.monthly_week_number
                                                            }),
                                                        ...(values.groupSchedule === '1' &&
                                                            values.eventType === 'monthly' &&
                                                            values.monthly_rec_type === 'dayOfMonth' && {
                                                                // monthly_weekday: values.monthly_week_day,
                                                                day_of_month: values.monthly_week_day
                                                            }),
                                                        ...(values.groupSchedule === '1' &&
                                                            (values.event_nature || !isTreatmentDataChange) && {
                                                                event_nature: !isTreatmentDataChange ? 'all-events' : values.event_nature
                                                            })
                                                    };

                                                    if (scheduleData && !values.group_schedule_id) {
                                                        // ******** FOR NON RECUURING EVENT
                                                        payload.sch_id = scheduleData.sch_id;
                                                    }
                                                    if (values.group_schedule_id && scheduleData && timeRecCompo) {
                                                        // ******** TIME AND RECCURENCE CHANGE
                                                        delete payload.event_nature;
                                                        payload.sch_id = scheduleData.sch_id;
                                                        payload.is_group_schedule = values.groupSchedule === '1' ? true : false;
                                                        await addEventCreate(payload).unwrap();
                                                    } else if (values.group_schedule_id && scheduleData && DateRecCompo) {
                                                        // ******** DATE AND RECCURENCE CHANGE
                                                        delete payload.event_nature;
                                                        payload.sch_id = scheduleData.sch_id;
                                                        payload.is_group_schedule = values.groupSchedule === '1' ? true : false;
                                                        await addEventCreate(payload).unwrap();
                                                    } else if (
                                                        values.group_schedule_id &&
                                                        scheduleData &&
                                                        isStartDateChange &&
                                                        values.eventType !== 'monthly'
                                                    ) {
                                                        // ******** ONLY FOR START DATE CHANGE

                                                        payload.start_date_time = moment(new Date(values.start))
                                                            .utc()
                                                            .format(PAYLOAD_DATE_TIME_FORMAT);
                                                        delete payload.event_type;
                                                        delete payload.no_of_occurence;
                                                        delete payload.end_date_time;
                                                        delete payload.week_days;
                                                        delete payload.week_day;
                                                        delete payload.week_number;
                                                        delete payload.day_of_month;
                                                        delete payload.event_nature;

                                                        payload.sch_id = scheduleData.sch_id;

                                                        await addEvent(payload).unwrap();
                                                    } else if (values.group_schedule_id && values.event_nature === 'this-event') {
                                                        // ******** FOR UPDATING THIS-EVENT SELECTION
                                                        payload.start_date_time = moment(new Date(values.start))
                                                            .utc()
                                                            .format(PAYLOAD_DATE_TIME_FORMAT);
                                                        delete payload.event_type;
                                                        delete payload.no_of_occurence;
                                                        delete payload.end_date_time;
                                                        delete payload.week_days;
                                                        delete payload.week_day;
                                                        delete payload.week_number;
                                                        delete payload.day_of_month;
                                                        delete payload.event_nature;

                                                        payload.sch_id = scheduleData.sch_id;

                                                        await addEvent(payload).unwrap();
                                                    } else if (values.group_schedule_id) {
                                                        //  ******** THIS AND UPCOMING && ALL EVENTS
                                                        payload.group_schedule = values.group_schedule_id;
                                                        if (scheduleData && isStartDateChange && values.eventType === 'monthly') {
                                                            // ******** ONLY FOR --MONTHLY --START DATE CHANGE
                                                            payload.event_nature = values.event_nature;
                                                            payload.group_schedule = values.group_schedule_id;
                                                            payload.update_type = 'schedule-monthly';
                                                            payload.org_start_date_time = moment
                                                                .utc(scheduleData?.start_date_time)
                                                                .local()
                                                                .format(PAYLOAD_DATE_TIME_FORMAT);
                                                        } else if (isRecChange) {
                                                            payload.update_type = 'recurrence';
                                                        } else if (isStartTimeChange) {
                                                            payload.event_nature = values.event_nature;
                                                            payload.update_type = 'schedule-time';
                                                            payload.org_start_date_time = moment
                                                                .utc(scheduleData?.start_date_time)
                                                                .local()
                                                                .format(PAYLOAD_DATE_TIME_FORMAT);
                                                        } else if (isTreatmentDataChange && !isStartDateChange && !isStartTimeChange) {
                                                            payload.update_type = 'schedule-basic-info';
                                                        }
                                                        //  else if (isGroupChange) {
                                                        //     payload.update_type = 'recurrence';
                                                        // }
                                                        else {
                                                            return;
                                                        }

                                                        await updateEvent(payload).unwrap();
                                                    } else {
                                                        //  ******** NORMAL CREATE
                                                        await addEvent(payload).unwrap();
                                                    }

                                                    notify({
                                                        message: scheduleData
                                                            ? 'Event updated successfully!'
                                                            : 'Event created successfully!',
                                                        severity: 'success'
                                                    });

                                                    formik.resetForm();
                                                    onCancel();
                                                    formik.setSubmitting(false);
                                                    setFieldValue('event_nature', '');
                                                    setEditParent('');
                                                } catch (error) {
                                                    console.error(error);
                                                    formik.setSubmitting(false);
                                                    notify({
                                                        message: error.data?.message || 'Something went wrong!',
                                                        severity: 'error'
                                                    });
                                                }
                                            }
                                        }}
                                    >
                                        {scheduleData ? 'Save' : 'Add'}
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    )}
                    <ConfirmationModal
                        open={showDelete}
                        handleClose={handleCloseDelete}
                        handleConfirm={() => {
                            handleDelete(
                                scheduleData?.sch_id,
                                values.event_nature,
                                values.group_schedule_id,
                                moment(new Date(values.start)).utc().format(PAYLOAD_DATE_TIME_FORMAT)
                            );
                            setFieldValue('event_nature', '');
                            setEditParent('');
                        }}
                        title="Delete Event"
                        description={`Are you sure you want to delete ${deleteMessage()}?`}
                    />
                </DialogActions>
            </Form>
            <ValidationDialog open={openValidation} onClose={handleValidationClose} validationResp={validationResp} />
        </FormikProvider>
    );
};

AddEventFrom.propTypes = {
    event: PropTypes.object,
    range: PropTypes.object,
    handleDelete: PropTypes.func,
    handleCreate: PropTypes.func,
    handleUpdate: PropTypes.func,
    onCancel: PropTypes.func
};

export default AddEventFrom;
